import { render, staticRenderFns } from "./changeBedManage.vue?vue&type=template&id=77d2db4f&scoped=true"
import script from "./changeBedManage.vue?vue&type=script&lang=js"
export * from "./changeBedManage.vue?vue&type=script&lang=js"
import style0 from "./changeBedManage.vue?vue&type=style&index=0&id=77d2db4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d2db4f",
  null
  
)

export default component.exports